<template>
  <!-- <card header-text="Users List"> -->
  <div class="card">
    <div class="card-header">
      <div class="row">
        <div class="col-md-10">
          <strong
            class="card-title mb-3"
          >{{'Portfolio List - '+ (fillableData.email)? fillableData.email: ''}}</strong>
        </div>
        <div class="col-md-1">
          <!-- <download :tableId="'users'" :fileName="'users-list'"></download> -->
        </div>
        <div class="col-md-1">
          <goback></goback>
        </div>
      </div>
    </div>
    <div class="card-body" v-if="fillableData.email">
      <div class="row mb5">
        <div class="col-md-3">
          <span v-if="fillableData">
            <strong>Purchased Value</strong>
            : {{getFixed(fillableData.total_purchased_value)}}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Sold Value</strong>
            : {{getFixed(fillableData.total_sell_value)}}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Sectors</strong>
            : {{(fillableData.no_of_sectors)}}
          </span>
        </div>
        <div class="col-md-3">
          <span v-if="fillableData">
            <strong>Avg holding period</strong>
            : {{getFixed(fillableData.avg_holding_period_in_years)}}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Avg sell period</strong>
            : {{getFixed(fillableData.avg_sell_period)}}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Stocks</strong>
            : {{(fillableData.no_of_stocks)}}
          </span>
        </div>
        <div class="col-md-6">
          <span v-if="fillableData">
            <strong>Sum of Latest Value/All values of comp.</strong>
            : {{(fillableData.total_sum_latest_value_per_all_values_of_company)}}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Sum of Latest Value</strong>
            : {{(fillableData.total_latest_value)}}
          </span>
          <br />
          <span v-if="fillableData">
            <strong>Total Profit & Loss</strong>
            : {{getFixed(fillableData.total_profit_or_loss)}}
          </span>
          <br />
          <span
            v-if="fillableData.all_latest_value_per_all_values_of_company_less_than_point_zero_one"
          >
            <strong>All latest values/All values of comp.(&lt; .01)</strong>
            : {{getFixed(fillableData.all_latest_value_per_all_values_of_company_less_than_point_zero_one)}}
          </span>
        </div>
      </div>
      <div class="clear-fix"></div>
      <div class="row">
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-10">
              <h4>Sectorwise Portfolios</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'sectorwiseportfolios'" :fileName="'sectorwise-portfolios'"></download>
            </div>
          </div>
          <div
            class="table-responsive mb15 app"
            v-dragscroll="true"
            v-if="fillableData.sectorwise_latest_value_per_all_values_of_company"
          >
            <table
              id="sectorwiseportfolios"
              class="table table-sm first-td-padding table-bordered app-inner"
            >
              <thead>
                <tr>
                  <!-- <th>Sector</th> -->
                  <th v-for="(sect, ind) in sectorFields" v-bind:key="'sector-th'+ind">{{sect.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in fillableData.sectorwise_total_return"
                  v-bind:key="'sector'+index"
                >
                  <!-- <td>{{Object.keys(row)[0]}}</td> -->
                  <td v-for="(sect, ind) in sectorFields" v-bind:key="'sector-td'+ind">
                    <span
                      v-if="sect.title!=='total_returns' && sect.title!=='total_returns_per_total_purchase'"
                    >{{(sect.isNumeric)? getFixed(row[sect.title]) : row[sect.title]}}</span>
                    <span
                      v-else-if="sect.title==='total_returns'"
                    >{{getFixed(row[sect.title])}}</span>
                    <span
                      v-else-if="sect.title==='total_returns_per_total_purchase'"
                    >{{getFixed(row[sect.title])}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-10">
              <h4>Portfolios</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'portfolios'" :fileName="'portfolios'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-if="fillableData.portfolios">
            <table id="portfolios" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th>Portfolio</th>
                  <th>Value</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row,index) in Object.keys(fillableData.portfolios)"
                  v-bind:key="'sector'+index"
                >
                  <td>{{getLabel(row)}}</td>
                  <td>{{getFixed(fillableData.portfolios[row])}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="row">
            <div class="col-md-10">
              <h4>Industry wise Portfolios</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'industrywise'" :fileName="'industrywise'"></download>
            </div>
          </div>
          <div
            class="table-responsive mb15 app"
            v-dragscroll
            v-if="fillableData.industryTypewise_latest_value_per_all_values_of_company"
          >
            <table
              id="industrywise"
              class="table table-sm first-td-padding table-bordered app-inner"
            >
              <thead>
                <tr>
                  <th>Industry Type</th>
                  <th>Latest value/All Values of companies</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row, index) in fillableData.industryTypewise_latest_value_per_all_values_of_company"
                  v-bind:key="'sector'+index"
                >
                  <td>{{(getCustomLabel(Object.keys(row)[0]))? getCustomLabel(Object.keys(row)[0]) : getLabel(Object.keys(row)[0])}}</td>
                  <td>{{getFixed(fillableData.industryTypewise_latest_value_per_all_values_of_company[index][Object.keys(row)[0]]['latest_value_per_all_values_of_company'])}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-8">
          <div class="row">
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-10">
                  <h4>Top Sector</h4>
                </div>
                <div class="col-md-1">
                  <download :tableId="'topsector'" :fileName="'topsector'"></download>
                </div>
              </div>
              <div class="table-responsive">
                <table
                  id="topsector"
                  class="table table-sm first-td-padding table-bordered app-inner"
                >
                  <tr v-for="(sect, ind) in sectorFields" v-bind:key="'sector-top'+ind">
                    <td class="text-bold">{{sect.name}}</td>
                    <td>
                      <span
                        v-if="sect.title!=='total_returns' && sect.title!=='total_returns_per_total_purchase'"
                      >{{(sect.isNumeric)? getFixed(fillableData.top_sector[sect.title]) : fillableData.top_sector[sect.title]}}</span>
                      <span
                      v-else-if="sect.title==='total_returns_per_total_purchase'"
                    >{{getFixed(fillableData.top_sector[sect.title])}}</span>
                      <span
                        v-else
                      >{{getFixed(fillableData.top_sector[sect.title])}}</span>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
            <div class="col-md-6">
              <div class="row">
                <div class="col-md-10">
                  <h4>Top Stock</h4>
                </div>
                <div class="col-md-1">
                  <download :tableId="'topstock'" :fileName="'topstock'"></download>
                </div>
              </div>
              <div class="table-responsive app">
                <table
                  id="topstock"
                  class="table table-sm first-td-padding table-bordered app-inner"
                >
                  <tr v-for="(ts, ind) in topBottomFields" v-bind:key="'stock-top'+ind">
                    <td class="text-bold">{{ts.name}}</td>
                    <td>{{(ts.isNumeric)? getFixed(fillableData.top_stock[ts.title]) : fillableData.top_stock[ts.title]}}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Top 3 Latest value per all values of company</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'toplvpertv'" :fileName="'top3lvpertv'"></download>
            </div>
          </div>
          <div
            class="table-responsive mb15 app"
            v-if="fillableData.top_3_latest_value_per_all_values_of_company"
          >
            <table id="toplvpertv" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th :key="'top'+index" v-for="(top, index) in topBottomFields">{{top.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row,index) in fillableData.top_3_latest_value_per_all_values_of_company"
                  v-bind:key="'top-row'+index"
                >
                  <td
                    :key="'top-td'+index"
                    v-for="(top, index) in topBottomFields"
                  >{{(top.isNumeric)? getFixed(row[top.title]): row[top.title]}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Bottom 3 Latest value per all values of company</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'btmlvpertv'" :fileName="'bottom3lvpertv'"></download>
            </div>
          </div>
          <div
            class="table-responsive mb15 app"
            v-if="fillableData.bottom_3_latest_value_per_all_values_of_company"
          >
            <table id="btmlvpertv" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th :key="'bot'+index" v-for="(bot, index) in topBottomFields">{{bot.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row,index) in fillableData.bottom_3_latest_value_per_all_values_of_company"
                  v-bind:key="'bot-row'+index"
                >
                  <td
                    :key="'bot-td'+index"
                    v-for="(bot, index) in topBottomFields"
                  >{{(bot.isNumeric)? getFixed(row[bot.title]): row[bot.title]}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-10">
              <h4>Latest value per all values of company (&lt; .01)</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'lvpertv'" :fileName="'lvpertvltpoint01'"></download>
            </div>
          </div>
          <div
            class="table-responsive mb15 app"
            v-if="fillableData.latest_value_per_all_values_of_company_less_than_point_zero_one"
          >
            <table id="lvpertv" class="table table-sm first-td-padding table-bordered app-inner">
              <thead>
                <tr>
                  <th :key="'less'+index" v-for="(less, index) in topBottomFields">{{less.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row,index) in fillableData.latest_value_per_all_values_of_company_less_than_point_zero_one"
                  v-bind:key="'less-row'+index"
                >
                  <td
                    :key="'less-td'+index"
                    v-for="(less, index) in topBottomFields"
                  >{{(less.isNumeric)? getFixed(row[less.title]): row[less.title]}}</td>
                </tr>
              </tbody>
              <tfoot
                v-if="fillableData.latest_value_per_all_values_of_company_less_than_point_zero_one.length===0"
              >
                <tr>
                  <td colspan="3">No data found</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-md-9">
              <h4>Cummulative Total Returns</h4>
            </div>
            <div class="col-md-1">
              <download :tableId="'cummulative-returns'" :fileName="'cummulative-returns'"></download>
            </div>
          </div>
          <div class="table-responsive mb15 app" v-if="fillableData.cummulative_total_returns">
            <table
              id="cummulative-returns"
              class="table table-sm first-td-padding table-bordered app-inner"
            >
              <thead>
                <tr>
                  <th :key="'less'+index" v-for="(less, index) in cummulativeFields">{{less.name}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(row,index) in fillableData.cummulative_total_returns"
                  v-bind:key="'less-row'+index"
                >
                  <td
                    :key="'less-td'+index"
                    v-for="(less, index) in cummulativeFields"
                  >{{(less.isNumeric)? getFixed(row[less.title]): row[less.title]}}</td>
                </tr>
              </tbody>
              <tfoot v-if="fillableData.cummulative_total_returns.length===0">
                <tr>
                  <td colspan="3">No data found</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-3">
          <h4>Stockwise Data</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersp1'" :fileName="'user-portfolio'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="usersp1" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in tableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row,index) in fillableData.stock_wise_data" v-bind:key="'row'+index">
              <td>{{index+1}}</td>
              <td v-for="field in tableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='name'">{{row['first_name']+' '+row['last_name']}}</span>
                <span
                  v-else-if="field.name === 'status' "
                >{{(row['status']===false)? 'Inactive':'Active'}}</span>
                <span
                  v-else-if="field.name === 'less_liquid_stock'"
                >{{(row['less_liquid_stock']===0)? 'No':'Yes'}}</span>
                <span v-else>
                  <span v-if="field.isNumeric">{{getChecknFixed(row[field.name])}}</span>
                  <span v-else-if="field.name==='date_of_sale'"> {{(row[field.name] !== curDate)? row[field.name]: '-'}}</span>
                  <span v-else-if="field.name==='date_of_purchase'"> {{(row[field.name] !== curDate)? row[field.name]: '-'}}</span>
                  <span
                    v-else-if="field.name === 'industry_type'"
                  >{{getCustomLabel(row[field.name])}}</span>
                  <span v-else>{{row[field.name]}}</span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{'Total'}}</td>
              <td v-for="field in tableFields" v-bind:key="'total_'+field.name">
                <span
                  v-if="field.isNumeric"
                >{{(fillableData['total_sum_'+field.name])? getChecknFixed(fillableData['total_sum_'+field.name]) :(fillableData['total_'+field.name])? getChecknFixed(fillableData['total_'+field.name]) : (fillableData['avg_'+field.name])? getChecknFixed(fillableData['avg_'+field.name]) : (fillableData['avg_'+field.name])? getChecknFixed(fillableData['avg_'+field.name]) : '-'}}</span>
                <span
                  v-else
                >{{(fillableData['total_'+field.name])? fillableData['total_'+field.name] : (fillableData['avg_'+field.name])? fillableData['avg_'+field.name] : '-'}}</span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
        <div class="pull-right" v-if="totalPages>1">
          <ul v-if="this.totalPages != 1" class="pagination">
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="goToPage(1)" href="#">&lt;&lt;</a>
            </li>
            <li :class="{disabled:prevDisabled}" class="page-item">
              <a class="page-link" @click.prevent="prev()" href="#">&lt;</a>
            </li>
            <li
              v-for="page in pages"
              v-bind:key="page"
              class="page-item"
              :class="(current_page == page)? 'active':''"
            >
              <a class="page-link" @click.prevent="goToPage(page)" href="#">{{page}}</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="next()">&gt;</a>
            </li>
            <li :class="{disabled:nextDisabled}" class="page-item">
              <a class="page-link" href="#" @click.prevent="goToPage(totalPages)">&gt;&gt;</a>
            </li>
          </ul>
        </div>
      </div>
      <div class="row mt15">
        <div class="col-md-3">
          <h4>Cummulative Data</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersp'" :fileName="'user-portfolio-cummulative'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="usersp" class="table table-sm first-td-padding table-bordered app-inner">
          <thead>
            <tr>
              <th>Sr.</th>
              <th v-for="field in cummTableFields" v-bind:key="'field'+field.title">{{field.title}}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row,index) in fillableData.cummulative_stock_wise_data"
              v-bind:key="'row'+index"
            >
              <td>{{index+1}}</td>
              <td v-for="field in cummTableFields" v-bind:key="field.name+index">
                <span v-if="field.name==='name'">{{row['first_name']+' '+row['last_name']}}</span>
                <span
                  v-else-if="field.name === 'status' "
                >{{(row['status']===false)? 'Inactive':'Active'}}</span>
                <span
                  v-else-if="field.name === 'stockwise_total_return_percent'"
                >{{getChecknFixed(fillableData.stockwise_total_return_percent[row['co_code']])}}</span>
                <span
                  v-else-if="field.name === 'less_liquid_stock'"
                >{{(row['less_liquid_stock']===0)? 'No':'Yes'}}</span>
                <span v-else>
                  <span v-if="field.isNumeric">{{getChecknFixed(row[field.name])}}</span>
                  <span
                    v-else-if="field.name === 'industry_type'"
                  >{{getCustomLabel(row[field.name])}}</span>
                  <span v-else>{{row[field.name]}}</span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{'Total'}}</td>
              <td v-for="field in cummTableFields" v-bind:key="'total_'+field.name">
                <span
                  v-if="field.isNumeric && field.name!=='total_returns'"
                >{{(fillableData['total_sum_'+field.name])? getChecknFixed(fillableData['total_sum_'+field.name]) : (fillableData['total_'+field.name])? getChecknFixed(fillableData['total_'+field.name]) : (fillableData['avg_'+field.name])? getChecknFixed(fillableData['avg_'+field.name]) : (fillableData['sum_total_'+field.name])? getChecknFixed(fillableData['sum_total_'+field.name]) :'-'}}</span>
                <span
                  v-else-if="field.name==='total_returns'">
                  {{getChecknFixed(fillableData['sum_total_return_value'])}}
                </span>
                <span v-else>{{(fillableData['total_'+field.name])? fillableData['total_'+field.name] : (fillableData['avg_'+field.name])? fillableData['avg_'+field.name] : '-'}}</span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="row mt15">
        <div class="col-md-3">
          <h4>Portfolio Values</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'usersportfoliovalues'" :fileName="'user-portfolio-values'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table
          id="usersportfoliovalues"
          class="table table-sm first-td-padding table-bordered app-inner"
        >
          <thead>
            <tr>
              <th></th>
              <th
                v-for="period in cummulativePeriodicValues"
                v-bind:key="'period'+period.title"
              >{{period.name}}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row,index) in fillableData.cummulative_stock_wise_data"
              v-bind:key="'row'+index"
            >
              <td>{{index+1}}</td>
              <td v-for="field in cummulativePeriodicValues" v-bind:key="field.title+index">
                <span>
                  <span
                    v-if="field.type==='numeric'"
                  >{{getChecknFixed(row['stock_price_no_of_share_'+field.title])}}</span>
                  <span
                    v-else-if="field.title === 'industry_type'"
                  >{{getCustomLabel(row[field.title])}}</span>
                  <span v-else>{{row[field.title]}}</span>
                </span>
              </td>
            </tr>
            <tr>
              <td>{{'Total'}}</td>
              <td v-for="field in cummulativePeriodicValues" v-bind:key="'total_'+field.name">
                <span
                  v-if="field.type==='numeric'"
                >{{(fillableData.portfolio['price_no_of_share_'+field.title])? getChecknFixed(fillableData.portfolio['price_no_of_share_'+field.title]) : '-'}}</span>
                <span
                  v-else
                >{{(fillableData.portfolio['price_no_of_share_'+field.title])? fillableData.portfolio['price_no_of_share_'+field.title] : '-'}}</span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="row mt15">
        <div class="col-md-3">
          <h4>Liquidity</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'liquidity'" :fileName="'liquidity'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table
          id="liquidity"
          class="table table-sm first-td-padding table-bordered app-inner"
        >
          <thead>
            <tr>
              <th></th>
              <th
                v-for="period in liquidityFields"
                v-bind:key="'period'+period.title"
              >{{period.name}}</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row,index) in fillableData.cummulative_stock_wise_data"
              v-bind:key="'row'+index"
            >
              <td>{{index+1}}</td>
              <td v-for="field in liquidityFields" v-bind:key="field.title+index">
                <span>
                  <span
                    v-if="field.type==='numeric'"
                  >{{getChecknFixed(row[field.title])}}</span>
                  <span
                    v-else-if="field.title === 'industry_type'"
                  >{{getCustomLabel(row[field.title])}}</span>
                  <span v-else>{{row[field.title]}}</span>
                </span>
              </td>
            </tr>
          </tbody>
          <tfoot v-if="fillableData.length==0">
            <tr>
              <td :colspan="(tableFields.length+1+actions.length)">
                <i class="fa fa-info cwhite"></i> No data found.
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <div class="row mt15">
        <div class="col-md-3">
          <h4>Dividend Earned</h4>
        </div>
        <div class="col-md-1">
          <download :tableId="'divearned'" :fileName="'div-earned'"></download>
        </div>
      </div>
      <div class="table-responsive mt15 app" v-dragscroll="true">
        <table id="divearned" class="table table-sm first-td-padding table-bordered app-inner">
          <!--<thead>
             <tr>
              <th></th>
              <th v-for="n in 10" v-bind:key="'field'+n">{{n}} Year</th>
            </tr>
          </thead>-->
          <tbody
            v-for="(row,index) in fillableData.yearly_dividend_earned"
            v-bind:key="'row'+index"
          >
            <tr>
              <th
                colspan="11"
              >{{fillableData.yearly_dividend_earned[index][Object.keys(row)[0]][0]['name_of_stock']}}</th>
            </tr>
            <tr v-for="(td, ind) in divEarnedTableFields" :key="'tdfi'+ind">
              <td :class="(ind===0)? 'text-bold': ''">{{td.name}}</td>
              <td :class="(ind===0)? 'text-bold': ''" v-for="n in 10" v-bind:key="'trtdfield'+n">
                <span>{{(fillableData.yearly_dividend_earned[index][Object.keys(row)[0]][n-1][td.title])}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/lib/http";
import { commonMixins } from "../../assets/mixins/common.js";
export default {
  components: {},
  mixins: [commonMixins],
  name: "UserPortfolio",
  props: ["user"],
  created() {
    if (!this.$route.params.id) {
      this.$router.push({ name: "user-listing" });
    }
    console.log("Config ", process.env.API_URL);
    this.url = this.apiUrl;
    this.userId = this.$route.params.id;
    console.log(
      this.url.indexOf("user-portfolio"),
      this.$route.params,
      this.$route.query
    );
    this.$route.query.page
      ? (this.pageToLoad = parseInt(this.$route.query.page))
      : (this.pageToLoad = "");
    this.url += this.pageToLoad;
    this.current_page = this.pageToLoad;
    this.fetchData(this.searchParams);
  },
  watch: {
    reload() {
      this.fillTable();
    },
    $route(to, from) {
      this.pageToLoad = to.query.page;
      console.log("watch route", to.query);
      // this.fetchData(to.query)
    }
  },
  data() {
    return {
      apiUrl: "frontend/getStockUserDetails",
      apiMode: true,
      curDate: ("0" + (new Date().getDate())).slice(-2)+'-'+("0" + (new Date().getMonth()+1)).slice(-2)+'-'+new Date().getFullYear(),
      company: {},
      actions: [],
      divEarnedTableFields: [
        {
          title: "year",
          name: "Year",
          isNumeric: true
        },
        {
          title: "no_of_share_held",
          name: "No. of Shares Held",
          isNumeric: true
        },
        {
          title: "dividend_per_share",
          name: "Dividend per share",
          isNumeric: true
        },
        { title: "dividend_earned", name: "Dividend Earned", isNumeric: true }
      ],
      tableFields: [
        {
          name: "name_of_stock",
          title: "Stock",
          isNumeric: 0
        },
        {
          name: "industry_type",
          title: "Market Cap",
          isNumeric: 0
        },
        {
          name: "sectorname",
          title: "Sector",
          isNumeric: 0
        },
        {
          name: "price_per_share",
          title: "Price/Share",
          isNumeric: 0
        },
        {
          name: "date_of_purchase",
          title: "Purchase Date",
          isNumeric: 0
        },
        {
          name: "price_at_which_sold",
          title: "Selling Price",
          isNumeric: 0
        },
        {
          name: "date_of_sale",
          title: "Selling Date",
          isNumeric: 0
        },
        {
          name: "latest_price",
          title: "Latest Price",
          isNumeric: 0
        },
        {
          name: "no_of_share_purchased",
          title: "No of shares purchased",
          isNumeric: 0
        },
        {
          name: "purchased_value",
          title: "Purchased Value",
          isNumeric: 0
        },
        {
          name: "no_of_share_sold",
          title: "No of shares Sold",
          isNumeric: 0
        },

        {
          name: "sell_value",
          title: "Sell Value",
          isNumeric: 0
        },
        {
          name: "no_of_share_held",
          title: "No of Shares Held",
          isNumeric: 0
        },
        {
          name: "holding_period_in_years",
          title: "Holding Period(Yrs)",
          isNumeric: 1
        },
        {
          name: "holding_period_in_years_sold_share",
          title: "Holding Period for Sold Shares(Yrs)",
          isNumeric: 1
        },
        {
          name: "latest_value",
          title: "Latest Value",
          isNumeric: 0
        }
      ],
      cummTableFields: [
        {
          name: "name_of_stock",
          title: "Stock",
          isNumeric: 0
        },
        {
          name: "industry_type",
          title: "Market Cap",
          isNumeric: 0
        },
        {
          name: "sectorname",
          title: "Sector",
          isNumeric: 0
        },
        {
          name: "latest_price",
          title: "Latest Price",
          isNumeric: 1
        },
        {
          name: "no_of_share_purchased",
          title: "No of shares purchased",
          isNumeric: 0
        },
        {
          name: "avg_price_per_share",
          title: "Avg Price/Share",
          isNumeric: 1
        },
        {
          name: "purchased_value",
          title: "Purchased Value",
          isNumeric: 0
        },
        {
          name: "avg_price_per_share_multiply_no_of_share_held",
          title: "Purchase cost for shares held",
          isNumeric: 1
        },
        {
          name: "no_of_share_sold",
          title: "No of shares Sold",
          isNumeric: 0
        },
        {
          name: "sell_value",
          title: "Sell Value",
          isNumeric: 0
        },
        {
          name: "avg_sale_price",
          title: "Avg Sale Price",
          isNumeric: 1
        },        
        {
          name: "no_of_share_held",
          title: "No of Shares Held",
          isNumeric: 0
        },
        {
          name: "days_to_sell",
          title: "Days to Sell",
          isNumeric: 1
        },
        {
          name: "profit_or_loss",
          title: "Profit/Loss",
          isNumeric: 1
        },
        {
          name: "unrealize_profit_or_loss",
          title: "Unrealized Profit/Loss",
          isNumeric: 1
        },
        {
          name: "unrealized_profit_loss_per_avg_price_per_share",
          title: "Unrealized Profit/Loss / Purchase cost for shares held",
          isNumeric: 1
        },
        {
          name: "unrealize_profit_or_loss_per_total_unrealize_profit_or_loss",
          title: "Unrealized Profit/Loss / Total Unrealized Profit/Loss",
          isNumeric: 1
        },
        {
          name: "liquidity",
          title: "Liquidity",
          isNumeric: 1
        },
        {
          name: "less_liquid_stock",
          title: "Less Liquid Stock",
          isNumeric: 1
        },
        {
          name: "dividend_earned",
          title: "Dividend Earned",
          isNumeric: 1
        },
        {
          name: "total_returns",
          title: "Total Returns",
          isNumeric: 1
        },
        {
          name: "percent_total_returns",
          title: "Total Returns/Purchase Cost",
          isNumeric: 1
        },
        {
          name: "stockwise_total_return_percent",
          title: "Percentage share of stock return",
          isNumeric: 1
        },
        {
          name: "valuation_q1_a_S_or_q1_b_S",
          title: "valuation Q1 A S / Q1 B S",
          isNumeric: 1
        },
        {
          name: "valuation_rating",
          title: "Valuation Rating",
          isNumeric: 0
        },
        {
          name: "p11_quarterly_trends_score",
          title: "P11 Quarterly Trend Score",
          isNumeric: 1
        },
        {
          name: "p11_quarterly_trends_score_star",
          title: "Quarterly Rating",
          isNumeric: 0
        },
        {
          name: "business_score",
          title: "Business Score",
          isNumeric: 1
        },
        {
          name: "business_rating",
          title: "Business Rating",
          isNumeric: 0
        },
        {
          name: "latest_value",
          title: "Latest Value",
          isNumeric: 0
        },
        {
          name: "latest_value_per_all_values_of_company",
          title: "Latest value/All Values",
          isNumeric: 1
        }
      ],
      liquidityFields: [
    { title: 'name_of_stock', name: 'Stock', isNumeric: 0, type: 'string', isLink: true, unit: '' },
    { title: 'no_of_share_held', name: 'No. of Shares held', isNumeric: 0, type: 'numeric', isLink: false, unit: '' },
    { title: 'avg_vol', name: 'Avg Volume traded', isNumeric: 1, type: 'numeric', isLink: false, unit: '' },
    { title: 'liquidity', name: 'No. of Shares held/Avg Volume', isNumeric: 1, type: 'numeric', isLink: false, unit: '' },
    { title: 'days_to_sell', name: 'Days to sell', type: 'numeric', isNumeric: 1, isLink: false, unit: '' },
    { title: 'less_liquid_stock', name: 'Less Liquidity', isNumeric: 1, type: 'boolean', isLink: false, unit: '' },
    { title: 'latest_value', name: 'Latest Value', isNumeric: 1, type: 'numeric', isLink: false, unit: '(Rs.)' },
    { title: 'latest_value_per_all_values_of_company', name: 'LV/TV', isNumeric: 1, type: 'numeric', isLink: false, unit: '(%)' },
  ],
      topBottomFields: [
        { title: "co_code", name: "Co Code", isNumeric: false },
        { title: "name_of_stock", name: "Company", isNumeric: false },
        {
          title: "latest_value_per_all_values_of_company",
          name: "Latest value/All Values of companies",
          isNumeric: true
        }
      ],
      sectorFields: [
        { title: "sectorname", name: "Sector", isNumeric: false },
        { title: "total_returns", name: "Total Returns", isNumeric: true },
        {
          title: "total_returns_per_total_purchase",
          name: "Total Returns/Purchase Cost",
          isNumeric: true
        },
        {
          title: "latest_value_per_all_values_of_company",
          name: "Latest value/All Values of companies",
          isNumeric: true
        }
      ],
      cummulativeFields: [
        { title: "name_of_stock", name: "Company", isNumeric: false },
        { title: "sectorname", name: "Sector", isNumeric: false },
        { title: "total_returns", name: "Total return", isNumeric: true },
        {
          title: "percentage_total_returns",
          name: "Total return %",
          isNumeric: true
        }
      ],
      compIndexFields: [
        { title: "IndexDate", name: "Date", isNumeric: false, type: "date" },
        { title: "IndexName", name: "Name", isNumeric: false, type: "string" },
        { title: "IndexValue", name: "Value", isNumeric: true, type: "number" },
        {
          title: "composite_index_value",
          name: "Composite Index Value",
          isNumeric: true,
          type: "number"
        }
      ],
      cummulativePeriodicValues: [
        { title: "name_of_stock", name: "Company", isNumeric: false },
        { title: "sectorname", name: "Sector", isNumeric: false },
        { title: "today", name: "Today", isNumeric: true, type: "numeric" },
        { title: "one_day", name: "1 Day", isNumeric: true, type: "numeric" },
        { title: "one_week", name: "1 Week", isNumeric: true, type: "numeric" },
        {
          title: "one_month",
          name: "1 Month",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "three_month",
          name: "3 Months",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "six_month",
          name: "6 Months",
          isNumeric: true,
          type: "numeric"
        },
        { title: "one_year", name: "1 Year", isNumeric: true, type: "numeric" },
        {
          title: "two_year",
          name: "2 Years",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "three_year",
          name: "3 Years",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "five_year",
          name: "5 Years",
          isNumeric: true,
          type: "numeric"
        },
        {
          title: "inception_date",
          name: "Since Inception",
          isNumeric: true,
          type: "numeric"
        }
      ],
      paginationPath: "",
      searchParams: {},
      sectorData: [],
      fillableData: [],
      url: "",
      current_page: 1,
      pageToLoad: 1,
      totalPages: 1,
      prevDisabled: 1,
      nextDisabled: 0,
      pages: [],
      userId: 0
    };
  },
  methods: {
    reset() {
      // window.location.reload();
      this.$router.push({ name: "user-listing" });
      this.searchParams = { userid: this.userId };
      this.pageToLoad = 1;
      this.current_page = 1;
      this.url = this.apiUrl + this.pageToLoad;
      this.fetchData(this.searchParams);
    },
    fetchData(data) {
      if (this.url !== "") {
        console.log("=====" + this.url + "========");
        let myself = this;
        let params = data ? { userid: this.userId } : {};
        http.post(this.url, params, function(error, response) {
          console.log(response);
          // if (response.responseType === "success") {
          myself.fillableData = response;
          // myself.current_page = myself.pageToLoad;
          // myself.totalPages = response.total_pages;
          // myself.prevDisabled = myself.pageToLoad == 1;
          // myself.nextDisabled = myself.current_page == myself.totalPages;
          // myself.isLoading = false;
          // // set 5 pages to show
          // console.log("current", myself.current_page);
          // let i = 5;
          // let page = myself.current_page - 2;
          // if (page <= 0) page = 1;
          // myself.pages = [];
          // while (i) {
          //   myself.pages.push(parseInt(page));
          //   if (myself.totalPages <= page) break;
          //   page++;
          //   i--;
          // }
          // console.log("PAges", myself.pages);
          // } else {
          //   console.log(error);
          // }
        });
      } else {
        console.log("=====" + this.url + "========");
      }
    },
    prev() {
      this.pageToLoad = this.current_page - 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    goToPage(page) {
      this.pageToLoad = page;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    next() {
      console.log(this.$route.query);
      this.pageToLoad = this.current_page + 1;
      this.$router.push({
        query: Object.assign({}, this.$route.query, { page: this.pageToLoad })
      });
      this.fillTable();
    },
    fillTable() {
      let url = this.apiUrl; //+"?a=1"
      if (this.pageToLoad != this.current_page) url += this.pageToLoad;
      this.url = url;
      this.fetchData(this.searchParams);
    },
    remove(index) {
      this.fillableData.splice(index, 1);
    },
    editUser(row, index, $event) {
      console.log(row, index, $event);
      http.get("user/" + row.id, {}, (error, response) => {
        this.$router.push({
          name: "edit-user",
          params: { user: response, isFromComp: 1 }
          // query: Object.assign({}, this.$route.query, { id: row.co_code })
        });
        //TODO:: add company updates into our array in future
      });
    }
  }
};
</script>
<style>
.table td {
  padding: 5px 10px 5px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/acl/user-portfolios.vue